import type { Form } from '../../../../common/types/form';
import type { Child } from '../../../../common/types/child';

const oldChildCareDataForm: Form<Child> = {
  key: 'oldChildCareData',
  title: 'Kinderbetreuung vor Frauenhaus',
  fields: [
    {
      key: 'oldChildCare',
      label: 'KG/Krippe/Hort',
      fieldTypes: 'select',
      options: [],
    },
    {
      key: 'oldChildCareGroup',
      label: 'Gruppe',
      fieldTypes: 'text',
    },
    {
      key: 'oldChildCareAdress',
      label: 'Adresse',
      fieldTypes: 'text',
      xsWidth: 12,
    },
    {
      key: 'oldChildCareContactPerson',
      label: 'Ansprechperson',
      fieldTypes: 'text',
    },
    {
      key: 'oldChildCareManagement',
      label: 'KiGa Leitung',
      fieldTypes: 'text',
    },
    {
      key: 'isExcusedOldChildCare',
      label: 'Entschuldigt',
      fieldTypes: 'checkbox',
    },
    {
      key: 'isDisenrolledOldChildCare',
      label: 'Abmeldung erfolgt',
      fieldTypes: 'checkbox',
    },
    {
      key: 'oldChildCareNotice',
      label: 'Notiz',
      fieldTypes: 'textArea',
      xsWidth: 12,
    },
  ],
};

export default oldChildCareDataForm;
